import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { RegionDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { RegionDto } from 'src/app/shared/models/user-management/region-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class RegionWorkItem extends WorkItem<RegionDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
    this._deletable = false;
  }
  get name(): string {
    return 'RegionWorkItem';
  }
  get database(): string {
    return RegionDB;
  }
}
